import { Navigate, Route, Routes } from 'react-router';
import { Login, ResetPassword, ResetPasswordChange, ResetPasswordChanged, ResetPasswordEnterEmail, ResetPasswordEnterCode, Signup, VerifiedEmail } from './pages/jwt';
import { AuthBrandedLayout } from '@/layouts/auth-branded';
import { AuthLayout } from '@/layouts/auth';
import { CheckEmail } from '@/auth/pages/jwt';
import { ActivationFailed } from './pages/active/ActivationFailed';

const AuthPage = () => <Routes>
    <Route element={<AuthBrandedLayout />}>
      <Route index element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/check-email" element={<CheckEmail />} />
      <Route path="/verified-email" element={<VerifiedEmail />} />
      <Route path="/activation-failed" element={<ActivationFailed />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/reset-password/enter-email" element={<ResetPasswordEnterEmail />} />
      <Route path="/reset-password/change" element={<ResetPasswordChange />} />
      <Route path="/reset-password/changed" element={<ResetPasswordChanged />} />
      <Route path="/reset-password/enter-code" element={<ResetPasswordEnterCode />} />
      <Route path="*" element={<Navigate to="/error/404" />} />
    </Route>

    <Route element={<AuthLayout />}>
      <Route path="/classic/login" element={<Login />} />
      <Route path="/classic/signup" element={<Signup />} />
      <Route path="/classic/check-email" element={<CheckEmail />} />
      <Route path="/classic/verified-email" element={<VerifiedEmail />} />
      <Route path="/classic/activation-failed" element={<ActivationFailed />} />
      <Route path="/classic/reset-password" element={<ResetPassword />} />
      <Route path="/classic/reset-password/enter-email" element={<ResetPasswordEnterEmail />} />
      <Route path="/classic/reset-password/change" element={<ResetPasswordChange />} />
      <Route path="/classic/reset-password/changed" element={<ResetPasswordChanged />} />
      <Route path="/classic/reset-password/enter-code" element={<ResetPasswordEnterCode />} />
      <Route path="*" element={<Navigate to="/error/404" />} />
    </Route>
  </Routes>;
export { AuthPage };